// Layout: About page
// 

JLM.MD.PageAbout = function( container ) {
	
	const INSTANCE = new JLM.MD.Module();
	
	
	// Variables: Private _______________________________________________________
	
	// References
	let areas = [],
		profile_photo, section_divisions;
	
	
	
	// Constructor ______________________________________________________________
	
	function init() {
		var observer_scroll;
		
		// References
		areas.push( $('.sec-intro', container) );
		areas.push( $('.sec-flow-a .sec-profile', container) );
		areas.push( $('.sec-flow-a .sec-flow-b .sec-divisions', container) );
		areas.push( $('.sec-flow-a .sec-flow-b .sec-contact', container) );
		profile_photo = $('figure', areas[1]);
		section_divisions = $('.sec-divisions', container);
		
		// Observed elements
		let observed_elements = [];
		areas.forEach(function(area) {
			observed_elements.push(area);
		});
		observed_elements.push( $('.sec-flow-a .sec-profile figure', container) );
		observed_elements.push( $('.sec-flow-a .sec-profile .blurb', container) );
		observed_elements.push( $('.sec-flow-a .sec-flow-b .sec-divisions .columns .column', container).eq(0) );
		observed_elements.push( $('.sec-flow-a .sec-flow-b .sec-divisions .columns .column', container).eq(1) );
		
		// Observer
		if ( window.IntersectionObserver ) {
			observer_scroll = new IntersectionObserver(function(entries, observer) {
				entries.forEach(function( entry ) {
					const target = $(entry.target);
					if ( entry.isIntersecting ) {
						target.addClass('reveal');
						observer.unobserve(target[0]);
					}
				});
			}, {
				rootMargin: "0px",
				threshold: 0
			});
			observed_elements.forEach(function(element) {
				observer_scroll.observe(element[0]);
			});
		} else {
			observed_elements.forEach(function(element) {
				element.addClass('reveal');
			});
		}
		
		// Events
		$(window).on('resize', mirrorPhotoHeight);
		
		// Init
		loadProfilePhoto();
		mirrorPhotoHeight();
	}
	
	
	
	// Methods: Private _________________________________________________________
	
	// Loads Imogen's photo
	// 
	function loadProfilePhoto() {
		let image_ele = $('<div class="image" />').appendTo( profile_photo ),
			image_src = image_ele.css('backgroundImage');
		image_src = image_src.replace(/(?:^url\(["']?|["']?\)$)/g, '');
		
		// No image
		if ( !image_src ) return;
		
		// Load image
		const image_mem = new Image();
		image_mem.onload = function() {
			setTimeout(function() {
				areas[1].addClass('loaded');
			}, 50);
		};
		image_mem.onerror = function() {};
		image_mem.src = image_src;
	}
	
	
	// Keep divisions section in-line with photo, if possible
	// 
	function mirrorPhotoHeight() {
		if ( $(window).width() >= 900 ) {
			var photo_height = profile_photo.outerHeight();
			section_divisions.css({ minHeight: photo_height + 'px' });
		} else {
			section_divisions.css({ minHeight: '' });
		}
	}
	
	
	
	// Initial Setup ____________________________________________________________
	
	init();
	return INSTANCE;
	
};